export const detectPageLocale = <T extends string>(
  storageKey: string,
  allowedLocales: readonly T[],
  fallbackLocale: T
): T => {
  if (typeof window === "undefined") {
    return fallbackLocale;
  }

  const stored = window.localStorage.getItem(storageKey);
  if (stored && allowedLocales.includes(stored as T)) {
    return stored as T;
  }

  const browserLocales = window.navigator.languages?.length
    ? window.navigator.languages
    : [window.navigator.language];

  for (const locale of browserLocales) {
    const normalized = locale.toLowerCase();
    if (normalized.startsWith("ko") && allowedLocales.includes("ko" as T)) return "ko" as T;
    if (normalized.startsWith("ja") && allowedLocales.includes("ja" as T)) return "ja" as T;
    if (normalized.startsWith("es") && allowedLocales.includes("es" as T)) return "es" as T;
    if (normalized.startsWith("fr") && allowedLocales.includes("fr" as T)) return "fr" as T;
    if (normalized.startsWith("pt") && allowedLocales.includes("pt_BR" as T)) return "pt_BR" as T;
    if (normalized.startsWith("vi") && allowedLocales.includes("vi" as T)) return "vi" as T;
    if (normalized.startsWith("en") && allowedLocales.includes("en" as T)) return "en" as T;
  }

  return fallbackLocale;
};
